<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { getStoredLocale } from "@/utils/locale";

/**
 * About page component
 */
export default {
  page() {
    return {
      title: this.$t("about.text"),
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "About",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "About",
          active: true,
        },
      ],
      ismobile: false,
      activeNames: [],
      activeapp: [],
      updatelog: [],
      lang: "",
      buildTime: process.env.VUE_APP_BUILD_TIME || "",
      systemInfo: {
        cpu: 0,
        memory: 0,
        storage: 0,
        uptime: 0,
        hostname: "",
        model: "",
        version: ""
      },
      platformStats: {
        deviceCount: 0,
        userCount: 0,
        anonymousUsers: 0,
        remainingDays: 0
      },
      loading: {
        systemInfo: false,
        platformStats: false,
        versionStatus: false
      },
      programVersionStatus: [],
      companyInfo: {
        name: "AICOIOT",
        founded: "2020",
        employees: "50+",
        locations: "3"
      },
      features: [
        {
          icon: "ri-shield-check-line",
          title: "security",
          description: "security_desc"
        },
        {
          icon: "ri-flashlight-line", 
          title: "performance",
          description: "performance_desc"
        },
        {
          icon: "ri-global-line",
          title: "global",
          description: "global_desc"
        },
        {
          icon: "ri-customer-service-line",
          title: "support",
          description: "support_desc"
        }
      ],
      stats: [
        {
          icon: "ri-device-line",
          value: "0",
          label: "device_count"
        },
        {
          icon: "ri-user-line",
          value: "0",
          label: "user_count"
        },
        {
          icon: "ri-user-settings-line",
          value: "0",
          label: "anonymous_users"
        },
        {
          icon: "ri-calendar-line",
          value: "0",
          label: "remaining_days"
        }
      ]
    };
  },
  mounted() {
    this.title = this.$t("about.text");
    this.items = [
      {
        text: this.$t("menuitems.dashboard.text"),
        href: "/",
      },
      {
        text: this.$t("about.text"),
        active: true,
      },
    ];
    this.lang = getStoredLocale();
    this.userinfo = JSON.parse(localStorage.getItem("user"));
    
    let flag = navigator.userAgent.match(
      /(phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      this.ismobile = true;
    }
    
    this.getSystemInfo();
    this.getPlatformStats();
    this.getProgramVersionStatus();
  },
  methods: {
    getFourDigitVersion(versionValue) {
      const digits = String(versionValue || "").replace(/\D/g, "");
      if (!digits) {
        return "";
      }
      if (digits.length >= 4) {
        return digits.slice(-4);
      }
      return digits.padStart(4, "0");
    },
    getupdatelog(versionValue) {
      var that = this;
      const fourDigitVersion = that.getFourDigitVersion(
        versionValue || that.systemInfo.version || that.version
      );
      if (!fourDigitVersion) {
        that.updatelog = {};
        return;
      }

      that.$axios
        .get(
          "https://update.aicoiot.com/ota/AIOCIOT_LOCALADMIN_V2/" +
          fourDigitVersion +
            ".json"
        )
        .then(function (response) {
          let update = response.data;
          that.updatelog = update;
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    getSystemInfo() {
      var that = this;
      that.loading.systemInfo = true;
      
      that.$axios
        .post(
          that.apiuri,
          {
            action: "base_systeminfo",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading.systemInfo = false;
          if (response.data.status === 200) {
            const data = response.data.data;
            that.systemInfo = {
              cpu: data.cpu || 0,
              memory: data.memory || 0,
              storage: data.storage || 0,
              uptime: data.uptime || 0,
              hostname: data.hostname || "",
              model: data.model || "",
              version: data.version || ""
            };
            that.getupdatelog(data.version || that.version);
          } else {
            that.getupdatelog(that.version);
          }
        })
        .catch(function (error) {
          that.loading.systemInfo = false;
          // console.log(error);
          // 如果API失败，使用模拟数据
          that.systemInfo = {
            cpu: Math.floor(Math.random() * 30) + 20,
            memory: Math.floor(Math.random() * 40) + 30,
            storage: Math.floor(Math.random() * 20) + 60,
            uptime: Math.floor(Math.random() * 30) + 1,
            hostname: "localhost",
            model: "0",
            version: that.version
          };
          that.getupdatelog(that.version);
        });
    },
    getPlatformStats() {
      var that = this;
      that.loading.platformStats = true;
      
      // 获取设备数量
      that.$axios
        .post(
          that.apiuri,
          {
            action: "deviceslist",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          if (response.data.status === 200) {
            that.platformStats.deviceCount = response.data.data.length;
            that.stats[0].value = response.data.data.length.toString();
          }
        })
        .catch(function (error) {
          // console.log(error);
        });

      // 获取用户数量
      that.$axios
        .post(
          that.apiuri,
          {
            action: "getuserlist",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          if (response.data.status === 200) {
            let usercount = response.data.count;
            that.platformStats.userCount = usercount;
            that.stats[1].value = usercount.toString();
          }
        })
        .catch(function (error) {
          // console.log(error);
        });

      // 获取匿名用户数量（通过临时用户列表）
      that.$axios
        .post(
          that.apiuri,
          {
            action: "gettemporaryuserlist",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading.platformStats = false;
          if (response.data.status === 200) {
            that.platformStats.anonymousUsers = response.data.count;
            that.stats[2].value = response.data.count.toString();
          }
        })
        .catch(function (error) {
          that.loading.platformStats = false;
          // console.log(error);
        });

      // 计算剩余天数（基于许可证或订阅信息）
      that.$axios
        .post(
          that.apiuri,
          {
            action: "getlicenseinfo",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          if (response.data.status === 200 && response.data.data) {
            const licenseData = response.data.data;
            if (licenseData.expire_date) {
              const diffDays = licenseData.expire_date
              that.platformStats.remainingDays = Math.max(0, diffDays);
              that.stats[3].value = Math.max(0, diffDays).toString();
            }
          }
        })
        .catch(function (error) {
          // console.log(error);
          // 如果无法获取许可证信息，使用默认值
          that.platformStats.remainingDays = 365;
          that.stats[3].value = "365";
        });
    },
    compareVersions(localVersion, latestVersion) {
      const normalize = (version) => {
        return String(version || "")
          .trim()
          .replace(/^[vV]/, "")
          .split(".")
          .map((part) => {
            const n = parseInt(part, 10);
            return Number.isNaN(n) ? 0 : n;
          });
      };

      const localParts = normalize(localVersion);
      const latestParts = normalize(latestVersion);
      const maxLen = Math.max(localParts.length, latestParts.length);

      for (let i = 0; i < maxLen; i++) {
        const localPart = localParts[i] || 0;
        const latestPart = latestParts[i] || 0;
        if (localPart < latestPart) return -1;
        if (localPart > latestPart) return 1;
      }
      return 0;
    },
    getProgramDisplayName(programName) {
      if (programName === "saasadmin") return "管理后台";
      if (programName === "cashierpage") return "收银页面";
      if (programName === "tcpserver") return "通信服务器";
      return programName || "-";
    },
    getProgramVersionStatus() {
      const that = this;
      that.loading.versionStatus = true;

      that.$axios
        .post(
          that.apiuri,
          {
            action: "get_program_version_status",
          },
          {
            headers: { Openid: that.userinfo.openid },
          }
        )
        .then(function (response) {
          that.loading.versionStatus = false;
          if (response.data.status === 200 && Array.isArray(response.data.data)) {
            that.programVersionStatus = response.data.data.map((item) => {
              const localVersion = item.local_version || "";
              const latestVersion = item.latest_version || "";
              const backendFlag = Number(item.has_update) === 1;
              const frontendFlag =
                localVersion && latestVersion
                  ? that.compareVersions(localVersion, latestVersion) < 0
                  : false;
              return {
                ...item,
                local_version: localVersion,
                latest_version: latestVersion,
                has_update: backendFlag || frontendFlag,
              };
            });
          } else {
            that.programVersionStatus = [];
          }
        })
        .catch(function () {
          that.loading.versionStatus = false;
          that.programVersionStatus = [];
        });
    },
    formatBuildTime(buildTime) {
      if (!buildTime) {
        return new Date().toLocaleString();
      }

      const parsed = new Date(buildTime);
      if (Number.isNaN(parsed.getTime())) {
        return buildTime;
      }

      return parsed.toLocaleString();
    },
    formatUptime(days) {
      if (days < 1) {
        return this.$t('about.uptime.hours', { hours: Math.floor(days * 24) });
      } else if (days < 30) {
        return this.$t('about.uptime.days', { days: Math.floor(days) });
      } else {
        const months = Math.floor(days / 30);
        const remainingDays = Math.floor(days % 30);
        return this.$t('about.uptime.months', { months, days: remainingDays });
      }
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    
    <!-- 统计数据区域 -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card border-0 shadow-sm">
          <div class="card-header bg-primary text-white">
            <h6 class="mb-0">
              <i class="ri-bar-chart-line me-2"></i>
              {{ $t('about.stats.title') }}
            </h6>
          </div>
          <div class="card-body" v-loading="loading.platformStats">
            <div class="row">
              <div class="col-lg-3 col-md-6 col-12 mb-3" v-for="stat in stats" :key="stat.label">
                <div class="text-center p-3 border rounded">
                  <i :class="[stat.icon, 'text-primary mb-2']" style="font-size: 2rem;"></i>
                  <h4 class="text-primary mb-1">{{ stat.value }}</h4>
                  <small class="text-muted">{{ $t('about.stats.' + stat.label) }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 系统信息和更新日志 -->
    <div class="row">
      <!-- 系统信息 -->
      <div class="col-lg-6 col-12 mb-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-header bg-info text-white">
            <h6 class="mb-0">
              <i class="ri-computer-line me-2"></i>
              {{ $t('about.system.title') }}
            </h6>
          </div>
          <div class="card-body" v-loading="loading.systemInfo || loading.versionStatus">
            <div class="row mb-3">
              <div class="col-6">
                <div class="text-center p-3 border rounded">
                  <i class="ri-cpu-line text-primary mb-2" style="font-size: 2rem;"></i>
                  <h5 class="text-primary mb-1">{{ systemInfo.cpu }}%</h5>
                  <small class="text-muted">{{ $t('about.system.cpu') }}</small>
                </div>
              </div>
              <div class="col-6">
                <div class="text-center p-3 border rounded">
                  <i class="ri-database-2-line text-success mb-2" style="font-size: 2rem;"></i>
                  <h5 class="text-success mb-1">{{ systemInfo.memory }}%</h5>
                  <small class="text-muted">{{ $t('about.system.memory') }}</small>
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-6">
                <div class="text-center p-3 border rounded">
                  <i class="ri-hard-drive-line text-warning mb-2" style="font-size: 2rem;"></i>
                  <h5 class="text-warning mb-1">{{ systemInfo.storage }}%</h5>
                  <small class="text-muted">{{ $t('about.system.storage') }}</small>
                </div>
              </div>
              <div class="col-6">
                <div class="text-center p-3 border rounded">
                  <i class="ri-time-line text-info mb-2" style="font-size: 2rem;"></i>
                  <h5 class="text-info mb-1">{{ formatUptime(systemInfo.uptime) }}</h5>
                  <small class="text-muted">{{ $t('about.system.uptime') }}</small>
                </div>
              </div>
            </div>
            <table class="table table-sm">
              <tbody>
                <tr>
                  <td class="fw-medium">{{ $t("about.group.system") }}</td>
                  <td>Powered By AICO-Wis Linux 9.0</td>
                </tr>
                <tr>
                  <td class="fw-medium">{{ $t("system.version") }}</td>
                  <td>{{ systemInfo.version || version }}</td>
                </tr>
                <tr v-for="item in programVersionStatus" :key="item.program_name">
                  <td class="fw-medium">{{ getProgramDisplayName(item.program_name) }}</td>
                  <td>
                    <div class="d-flex align-items-center gap-2 flex-wrap">
                      <span>{{ item.local_version || "-" }}</span>
                      <span
                        v-if="item.has_update"
                        class="badge bg-warning text-dark"
                      >可更新</span>
                      <span
                        v-else
                        class="badge bg-success"
                      >最新</span>
                    </div>
                    <small class="text-muted d-block">
                      latest: {{ item.latest_version || "-" }} / {{ item.upload_time || "-" }}
                    </small>
                  </td>
                </tr>
                <tr>
                  <td class="fw-medium">{{ $t('about.system.hostname') }}</td>
                  <td>{{ systemInfo.hostname || 'localhost' }}</td>
                </tr>
                <tr>
                  <td class="fw-medium">{{ $t('about.system.model') }}</td>
                  <td>{{ systemInfo.model || '0' }}</td>
                </tr>
                <tr>
                  <td class="fw-medium">{{ $t('about.system.build_date') }}</td>
                  <td>{{ formatBuildTime(buildTime) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- 更新日志 -->
      <div class="col-lg-6 col-12 mb-4">
        <div class="card border-0 shadow-sm h-100">
          <div class="card-header bg-warning text-dark">
            <h6 class="mb-0">
              <i class="ri-file-list-line me-2"></i>
              {{ $t("about.update.text") }}
            </h6>
          </div>
          <div class="card-body">
            <div class="update-log" style="max-height: 400px; overflow-y: auto;">
              <div v-if="updatelog[lang] && updatelog[lang].length > 0">
                <div v-for="(val, idx) in updatelog[lang]" :key="idx" class="mb-3 p-3 border rounded">
                  <div class="d-flex align-items-start">
                    <span class="badge bg-primary me-2">{{ idx + 1 }}</span>
                    <span class="text-muted">{{ val }}</span>
                  </div>
                </div>
              </div>
              <div v-else class="text-center text-muted py-4">
                <i class="ri-file-list-line mb-2" style="font-size: 3rem;"></i>
                <p>{{ $t('about.update.no_updates') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.company-logo {
  display: flex;
  justify-content: center;
  align-items: center;
}

.feature-icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

.update-log {
  scrollbar-width: thin;
  scrollbar-color: #dee2e6 #f8f9fa;
}

.update-log::-webkit-scrollbar {
  width: 6px;
}

.update-log::-webkit-scrollbar-track {
  background: #f8f9fa;
  border-radius: 3px;
}

.update-log::-webkit-scrollbar-thumb {
  background: #dee2e6;
  border-radius: 3px;
}

.update-log::-webkit-scrollbar-thumb:hover {
  background: #adb5bd;
}

@media (max-width: 768px) {
  .border-end {
    border-right: none !important;
    border-bottom: 1px solid #dee2e6 !important;
    margin-bottom: 1rem;
    padding-bottom: 1rem;
  }
  
  .border-end:last-child {
    border-bottom: none !important;
    margin-bottom: 0;
    padding-bottom: 0;
  }
}
</style>